
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l5vdF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ibzAc = parcelRequire("ibzAc");


var $etuMO = parcelRequire("etuMO");


var $1DWH0 = parcelRequire("1DWH0");


var $32x2E = parcelRequire("32x2E");

// next/packages/emoji-title/src/EmojiComponent.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc170b51986f269a$var$EmojiSpan = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1jaAuLnQyn _1vklRSnQyn _430i96Pcut _0mzAWiPcut",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $cc170b51986f269a$var$SkeletonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1frub2c": (0, $7sObp.default)(__cmplp.size)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1EqgXlXjOh _3iDTPbvbI6 _0jFU0V59Fr _39xV0259Fr",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $cc170b51986f269a$var$EmojiSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1frub2c": (0, $7sObp.default)(__cmplp.size)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2uo31fGsB2 _4ya3eE59Fr _39xV0259Fr _0jFU0V59Fr",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $cc170b51986f269a$var$EMOJI_HEIGHT_MINI = 20;
const $cc170b51986f269a$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(5);
    const t0 = `${props.height || 20}px`;
    const t1 = `${props.height || 20}px`;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$EmojiSkeleton, {
            size: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t0 || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$SkeletonWrapper, {
            size: t0,
            "data-testid": "emoji-placeholder"
        }, t2);
        $[2] = t0;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
/**
 *
 * @param param
 *
 * In order to load media emojis we need a few parameters
 * Because Emojis within ADF provides: shortName, Id, text
 * (e.g)
 *     "shortName": ":slight_smile:",
 *     "id": "1f642",
 *     "text": "🙂"
 */ const $cc170b51986f269a$var$FetchedEmojiComponent = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { id: id, shortName: shortName, cloudId: cloudId, userId: userId } = t0;
    let t1;
    if ($[0] !== id || $[1] !== shortName) {
        t1 = {
            id: id,
            shortName: shortName
        };
        $[0] = id;
        $[1] = shortName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== cloudId || $[4] !== userId) {
        t2 = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
        $[3] = cloudId;
        $[4] = userId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc170b51986f269a$var$EmojiSpan, {
            "data-testid": "toc-emoji-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
            emojiId: t1,
            emojiProvider: t2,
            fitToHeight: $cc170b51986f269a$var$EMOJI_HEIGHT_MINI,
            showTooltip: false
        }));
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
const $cc170b51986f269a$export$8d59648ac142d001 = (0, $1DWH0.default)()($cc170b51986f269a$var$FetchedEmojiComponent);
module.exports["EmojiPlaceholder"] = $cc170b51986f269a$export$9fc60f86d5a6479f;
module.exports["EmojiComponent"] = $cc170b51986f269a$export$8d59648ac142d001;

});


//# sourceMappingURL=EmojiComponent.8c8dba9f.js.map
